import { useState, useEffect } from "react";

function EditableCellNumber({ value, setValueTable, rowIndex, columnKey, clase}) {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value || 0); 
  }, [value]);

  return (
    <td
      className="color align-middle white-space-nowrap text-body py-1 text-end"
      onClick={() => setIsEditing(true)}
      style={{
        maxWidth: "150px",
        textAlign: "right",
      }}
    >
      {isEditing ? (
        <input
          type="number"
          className="form-control form-control-sm rounded-4 border-0"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={() => {
            let newValue = parseFloat(inputValue);
            if (isNaN(newValue) || newValue < 0) newValue = 0; 
            setIsEditing(false);
            setInputValue(newValue)
            setValueTable({
              rowIndex,
              columnKey,
              inputValue: newValue,
            });
          }}
          autoFocus
          style={{ width: "100%", textAlign: "left" }}
        />
      ) : (
        <span className={clase}>
          {parseFloat( (inputValue < 0) ? 0 : inputValue).toFixed(2)} {clase === "" ? "" : "%"} 
        </span>
      )}
    </td>
  );
}

function EditableCellTextarea({ value , setValueTable , rowIndex, columnKey}) {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <td
      className="align-middle py-2"
      onClick={() => setIsEditing(true)}
      style={{
        maxWidth: "200px",
        wordWrap: "break-word",
        whiteSpace: "normal",
      }}
    >
      {isEditing ? (
        <textarea
          className="form-control form-control-sm rounded-4 border-0"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={() =>{
             setIsEditing(false);
             setValueTable({
                rowIndex, 
                columnKey,
                inputValue
              }) 
            }}
          autoFocus
          style={{ width: "100%", height: "50px" }}
        />
      ) : (
        inputValue
      )}
    </td>
  );
}

function EditableCellText({ value , setValueTable , rowIndex, columnKey}) {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <td
      className="align-middle py-2"
      onClick={() => setIsEditing(true)}
      style={{
        maxWidth: "150px",
        wordWrap: "break-word",
        whiteSpace: "normal",
      }}
    >
      {isEditing ? (
        <input
          type="text"
          className="form-control form-control-sm rounded-4 border-0"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={() =>{
            setIsEditing(false);
            setValueTable({
              rowIndex,
              columnKey,
              inputValue
            }) 
           }}
          autoFocus
          style={{ width: "100%"}}
        />
      ) : (
        inputValue
      )}
    </td>
  );
}

export { EditableCellText, EditableCellNumber, EditableCellTextarea };
